import { Router, Route, Switch, RouteComponentProps } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Suspense } from 'react';
import GeneralError from '../../shared/components/GeneralError';
import Eligibility from './views/Eligibility';
import { EligibleProgramsView } from './views/EligibleProgramsView';
import { LeadInfoView } from './views/LeadInfoView';
import { HubSpot } from './views/HubSpot';
import { UserAccountCreation } from './views/UserAccountCreation';
import { HistoryBackPrompt } from '../../shared/components/HistoryBackPrompt';
import { EligibilityBanner } from './views/EligibilityBanner';

const SentryRoute = Sentry.withSentryRouting(Route);
const globalQueryClient = new QueryClient();

function App({ history }: Pick<RouteComponentProps, 'history'>) {
  return (
    <QueryClientProvider client={globalQueryClient}>
      <Router history={history}>
        <Sentry.ErrorBoundary fallback={GeneralError}>
          <Suspense fallback={null}>
            <EligibilityBanner />
          </Suspense>
          <Switch>
            <SentryRoute exact path="/eligibility/:submissionId/result" render={() => <EligibleProgramsView />} />
            <SentryRoute exact path="/eligibility/:submissionId/contact_info" render={() => <LeadInfoView />} />
            <SentryRoute exact path="/eligibility/:submissionId/book_a_time" render={() => <HubSpot />} />
            <SentryRoute exact path="/eligibility/:submissionId/sign_up" render={() => <UserAccountCreation />} />
            <SentryRoute path="/eligibility" render={() => <Eligibility />} />
          </Switch>
          <HistoryBackPrompt />
        </Sentry.ErrorBoundary>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
